<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
      <v-row no-gutters fill-height>
        <v-col cols="12">
          <i-card-vertical :headerTitle="menuTitle" >
            <template v-slot:body>
              <v-layout column overflow-auto>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2">
                          <i-label :label="'Material Division : '"/>
													<v-col cols="2">
														<v-select
																v-model="division"
																:items="divisionList"
																return-object
																single-line
																outlined
																dense
																@change="changeDivision()"
														></v-select>
													</v-col>
                          <i-label :label="'Receive : '" class="pl-2"/>
													<v-col cols="2">
														<v-select
																v-model="receive"
																:items="receiveList"
																return-object
																single-line
																outlined
																dense
																@change="changeReceive()"
														></v-select>
													</v-col>
                          <i-label :label="'Submit : '" class="pl-2"/>
													<v-col cols="2">
														<v-select
																v-model="submit"
																:items="submitList"
																return-object
																single-line
																outlined
																dense
																@change="changeSubmit()"
														></v-select>
													</v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" class="pa-0">
                    <DxDataGrid id="departmentInformation" 
                      :class="[dataList2.length > 0 ? '' : 'listBox']"
                      :height="dataList2.length > 0 ? '500px' : ''"
                      :ref="epms3000Ref"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared"
                    >
                      <!-- <DxEditing :use-icons="true" /> -->
                      <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="quotNo" caption="Quotation No" width="10%" data-type="string" alignment="center" cell-template="quotNoTemplate" :allow-editing="false" />
                        <template #quotNoTemplate="{ data }">
                          <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="goDetail(data)" >
                            {{data.text}}
                          </v-btn>
                        </template>
                      <DxColumn data-field="buyerNm" caption="Purchase Charger" width="15%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="quotTitle" caption="Title" width="28%" data-type="string" alignment="center" cell-template="quotTitleTemplate" :allow-editing="false" />
                        <template #quotTitleTemplate="{ data }">
                          <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="goDetail(data)" >
                            {{data.text}}
                          </v-btn>
                        </template>
                      <DxColumn data-field="startDte" caption="Start Time" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="finishDte" caption="Finish Time" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="receiveYn" caption="Receive" width="7%" data-type="string" alignment="center" cell-template="ReceiveTemplate" :allow-editing="false" />
                        <template #ReceiveTemplate="{ data }">
                          <div>
                            <div :style="data.value == 'Y' ? 'display: none' : ''">
                              <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="goReceive(data)" >
                                <v-icon small class="mt-n1">
                                  mdi-arrow-right-box
                                </v-icon>
                                Receive
                              </v-btn>
                            </div>
                            <div :style="data.value == 'Y' ? '' : 'display: none' ">
                              <v-icon small class="mt-n1" color="blue" >
                                mdi-checkbox-marked-circle
                              </v-icon>
                            </div>
                          </div>
                        </template>
                      <DxColumn data-field="submitYn" caption="Submit" width="7%" data-type="string" alignment="center" cell-template="submitTemplate" :allow-editing="false" />
                        <template #submitTemplate="{ data }">
                          <div>
                            <div :style="data.text == 'Y' ? 'display: none' : ''">
                              <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="goSubmit(data)" >
                                <v-icon small class="mt-n1">
                                  mdi-arrow-right-box
                                </v-icon>
                                Make
                              </v-btn>
                            </div>
                            <div :style="data.text == 'Y' && data.text != null  ? '' : 'display: none' ">
                              <v-icon small class="mt-n1" color="blue">
                                mdi-checkbox-marked-circle
                              </v-icon>
                            </div>
                          </div>
                        </template>
                      <DxColumn data-field="" caption="View Sheet" width="10%" data-type="string" alignment="center" cell-template="sheetTemplate" :allow-editing="false" />
                        <template #sheetTemplate="{ data }">
                          <div>
                            <v-row no-gutters>
                              <v-col cols="6">
                                <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="porSheet(data)" >
                                  <v-icon small class="mt-n1">
                                    mdi-arrow-right-box
                                  </v-icon>
                                  POR
                                </v-btn>
                              </v-col>
                              <v-col cols="6">
                                <v-btn small elevation="0" color="transparent" class="px-1 py-0 ReceiveBtn" @click="bomList(data)" >
                                  <v-icon small class="mt-n1">
                                    mdi-arrow-right-box
                                  </v-icon>
                                  BOM
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </template>
                      <DxPaging :enabled="true" :page-size="30" />
                    </DxDataGrid>

                    <i-card-vertical v-show="dataList2.length > 0" :headerTitle="'Waste Selling Quotation List'" >
                    <template v-slot:body>
                        <v-row>
                          <v-col cols="12" class="pa-0">
                            <DxDataGrid
                              :ref="epms3000Ref2"
                              :data-source="dataList2" 
                              :remote-operations="false" 
                              :hover-state-enabled="true"
                              :allow-column-resizing="true" 
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true" 
                              :show-borders="true" 
                              :width="grid.width"
                              :show-row-lines="true" 
                              key-expr="id" 
                              :focused-row-enabled="true"
                              :column-hiding-enabled="false" 
                              :selection="{ mode: 'none' }"
                              :word-wrap-enabled="true"
                              @cellPrepared="cellPrepared"
                            >
                              <DxColumn data-field="id" caption="No" width="3%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="quotNo" caption="Quotation No" width="8%" data-type="string" alignment="center" :visible="true" cell-template="quotNoTemplate" :allow-editing="false" />
                              <template #quotNoTemplate="{ data }">
                                <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="goDetail(data)" >
                                  {{ data.value }}
                                </v-btn>
                              </template>
                              <DxColumn data-field="buyerNm" caption="Purchase Charger" width="15%" data-type="left" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="quotTitle" caption="Title" data-type="string" alignment="left" :visible="true" cell-template="quotTitleTemplate" :allow-editing="false" />
                              <template #quotTitleTemplate="{ data }">
                                <!-- <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="goDetail(data)" >
                                  {{ data.value }}
                                </v-btn> -->
                                <span class="text-hover bold-hover cursor-pointer" @click.stop="goDetail(data)">
                                  {{ data.value }}
                                </span>
                              </template>
                              <DxColumn data-field="startDte" caption="Start Time" width="8%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="finishDte" caption="Finish Time" width="8%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                              <DxColumn data-field="receiveYn" caption="Recieve" width="6%" alignment="center" :visible="true" cell-template="recieveTemplate" :allow-editing="false" />
                              <template #recieveTemplate="{ data }">
                                <template v-if="data.value === 'Y'">
                                  <v-icon small class="mt-n1" color="blue" >
                                    mdi-checkbox-marked-circle
                                  </v-icon>
                                </template>
                                <template v-else>
                                  <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="receiveQuot(data.data)">
                                    <v-icon small class="mt-n1">
                                      mdi-arrow-right-box
                                    </v-icon>
                                    Recieve
                                  </v-btn>
                                </template>
                              </template>
                              <DxColumn data-field="submitYn" caption="Submit" width="6%" data-type="string" alignment="center" :visible="true"  cell-template="submitTemplate" :allow-editing="false" />
                              <template #submitTemplate="{ data }">
                                <template v-if="data.value === 'Y'">
                                  <v-icon small class="mt-n1" color="blue" >
                                    mdi-checkbox-marked-circle
                                  </v-icon>
                                </template>
                                <template v-else>
                                  <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click.stop="makeQuot(data.data)">
                                    <v-icon small class="mt-n1">
                                      mdi-arrow-right-box
                                    </v-icon>
                                    Make
                                  </v-btn>
                                </template>
                              </template>
                              <DxColumn data-field="" caption="View Sheet" width="10%" data-type="string" alignment="center" :visible="true" cell-template="viewSheetTemplate" :allow-editing="false" />
                                <template #viewSheetTemplate>                                 
                                </template>
                            </DxDataGrid>
                          </v-col>
                        </v-row>
                    </template>
                  </i-card-vertical>

                  </v-col>
                </v-row>
              </v-layout>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { DxDataGrid, DxEditing, DxColumn , DxButton } from 'devextreme-vue/data-grid'
  import ICardVertical from '@/components/common/iCardVertical.vue'
  import iCardTop from '@/components/common/iCardTop.vue'
  import baseview from '@/components/base/baseview.vue' // base page 추가
  import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
  import notify from 'devextreme/ui/notify' // message
  import { getRequestList, getWasteSellList , goReceive } from '@/api/view/hip/common/common.js'
  import { reportView } from '@/api/view/hip/common/common.js'
  
  export default {
    name: 'epms3000',
    mixins: [baseview, BaseDataGrid],
    components: {
      ICardVertical,
      'i-card-top': iCardTop,
      DxDataGrid,
      DxColumn,
      DxEditing,
      DxButton,
    },
    data() {
      return {
        menuTitle: this.$route.meta.title,
        epms3000Ref: 'epms3000Ref',
        epms3000Ref2: 'epms3000Ref2',
        gridMainList: [],
        dataList2: [],
        //select
				division: 'ALL',
				divisionList: ['ALL' , 'Bidding Material' , 'Long Time Contract' , 'Outside Repair'],
				receive: 'ALL',
				receiveList: ['ALL' , 'Already Received' , 'Not yet Receive' ],
				submit: 'ALL',
				submitList: ['ALL' , 'Already Received' , 'Not yet Receive' ],

        //parm
        makerCd: '',
        receiveYn: '',
        submitYn: '',
        userId: '',
        matlDiv: '',

      }
    },
    computed: {
      gridMainInstance() {
        return this.GetDataGrid(this.epms3000Ref)
      },
      gridMainInstance2() {
      return this.GetDataGrid(this.epms3000Ref2)
    }
    },
    mounted(){
      this.doSearchMain()
    },
    methods: {
      async doSearchMain(){
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
          quotStep: 'C',
          receiveYn: this.receiveYn,
          submitYn: this.submitYn,
          matlDiv: this.matlDiv,
          userId: this.$store.state.user.userId,
        }
        await getRequestList(params).then(res => {
          if(res.list.length){
            let cnt = 1
            res.list.forEach(e => {
              e.id = cnt
              e.no = cnt++
             // e.receiveYn = 'N'
            });
            this.gridMainList = res.list
           // console.log(this.gridMainList)
          }
        }).finally(() => {
          this.endLoading()
        })

        await getWasteSellList(params).then(res => {
        
        this.dataList2 = res.list
      }).finally(() => {
        this.endLoading()
      })

      },
      cellPrepared(e){
        if(e.rowType === 'data'){
          e.cellElement.style.padding = '1px'
        }
      },
        goDetail(e) {       
          //console.log(e) 
        this.$router.push({name: 'epms3010' , params:{quotNo: e.values[1], quotStep: e.data.quotStep}});
      },
      goReceive(e){
        let params = {
          quotNo: e.values[1],
          makerCd: this.$store.state.user.makerCd,
          quotStep: this.gridMainList[e.rowIndex].quotStep
        }
      
        this.vToastifyPrompt(
          this.$t('Do you want to receive the Quotation Request?'),
          'info',
            current => {
            this.openLoading('searching')
            goReceive(params)
              .then(res => {
                const msg = res.body
                if(msg === 'OK') {
                  notify(this.$t('Receipt Bid Quotation is completed.'), 'success', 3000)
                  this.doSearchMain()
                } else {
                  this.vToastify(this.$t(msg), 'warn')
                }

              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
            },
          null,
          true
        )
      },
      goSubmit(e){
        if(e.values[6] != null && e.values[6] != 'Y'){
          this.vToastify(this.$t('The quotation is not yet received.'), 'warn')
          return
        }
       //console.log(e)
        
        if (e.data.quotDiv === 'L') {
              this.$router.push({ name: 'epms3030', params: { quotNo: e.values[1], quotStep: e.data.quotStep } });
            } else if (e.data.quotDiv === 'O') {
              this.$router.push({ name: 'epms3040', params: { quotNo: e.values[1], quotStep: e.data.quotStep } });
            } else if (e.data.quotNo.includes('WM')) {
              this.$router.push({ name: 'epms3020_waste', params: { quotNo: e.values[1], quotStep: e.data.quotStep } });
            } else {
              this.$router.push({ name: 'epms3020', params: { quotNo: e.values[1], quotStep: e.data.quotStep } });
         }                            
      },
      porSheet(e){
        const param = {
          fileName: 'por_sheet.jrxml',
          as_quot_no: e.values[1]
          // as_quot_no: 'QT2212-0288'
        }
        this.openLoading('searching')
        reportView(param)
        .finally(() => {
          this.endLoading()
        })
      },
      bomList(e){
        const param = {
          fileName: 'bom_list.jrxml',
          as_quot_no: e.values[1]
        }
        console.log(param)
        this.openLoading('searching')
        reportView(param)
        .finally(() => {
          this.endLoading()
        })
      },

      // select data change
			changeDivision(){
        if(this.division == 'ALL'){
          this.matlDiv = ''
        }else if(this.division == 'Bidding Material'){
          this.matlDiv = 'Y'
        }else if(this.division == 'Long Time Contract'){
          this.matlDiv = 'N'
        }else {
          this.matlDiv = 'O'
        }
        this.doSearchMain()
			},
			changeReceive(){
        if(this.receive == 'ALL'){
          this.receiveYn = ''
        }else if(this.receive == 'Already Received'){
          this.receiveYn = 'Y'
        }else {
          this.receiveYn = 'N'
        }
        this.doSearchMain()
			},
			changeSubmit(){
        if(this.submit == 'ALL'){
          this.submitYn = ''
        }else if(this.submit == 'Already Received'){
          this.submitYn = 'Y'
        }else {
          this.submitYn = 'N'
        }
        this.doSearchMain()
			},
    }
  }
  </script>
  <style lang="scss" scoped>
    .subTitle {
      font-weight: bold;
      color: black;
    }
    .vat {
      color: blue;
    }
    .ReceiveBtn {
      font-weight: bold;
    }
    .ReceiveBtn:hover {
      color: #4980BC;
    }
    .v-btn {
      text-transform: unset !important;
      // height: 16px !important;
    }
  </style>